<div style="min-height:100vh;display:flex;align-items:center;justify-content:center;background:#f6f7f9;padding:24px;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif;">
  <div style="width:100%;max-width:420px;background:#fff;border:1px solid #e5e7eb;border-radius:16px;padding:32px;box-shadow:0 1px 3px rgba(0,0,0,.06);">

    <!-- Loading -->
    <div *ngIf="loading" style="text-align:center;color:#6b7280;">
      <p style="margin:0;font-size:14px;">Checking your invite…</p>
    </div>

    <!-- Invalid / expired / taken -->
    <div *ngIf="!loading && !valid" style="text-align:center;">
      <!-- Was (2026-10-07, ws 9b-1 final review): the generic text only. An expired link now says so. -->
      <p *ngIf="expired" style="margin:0 0 20px;font-size:14px;color:#6b7280;">{{ expiredText }}</p>
      <h1 *ngIf="!expired" style="margin:0 0 8px;font-size:18px;font-weight:600;color:#111827;">Invite no longer valid</h1>
      <p *ngIf="!expired" style="margin:0 0 20px;font-size:14px;color:#6b7280;">This invite link has expired, was cancelled, or has already been used. Ask your administrator for a new one.</p>
      <button (click)="navigateHome()" style="background:#111827;color:#fff;border:none;border-radius:10px;padding:11px 20px;font-size:14px;font-weight:600;cursor:pointer;">Go to sign in</button>
    </div>

    <!-- Accept form (signup: set a password) -->
    <div *ngIf="!loading && valid && !done && kind === 'signup'">
      <p style="margin:0 0 4px;font-size:12px;font-weight:600;letter-spacing:.4px;text-transform:uppercase;color:#6b7280;">You're invited</p>
      <h1 style="margin:0 0 6px;font-size:22px;font-weight:600;color:#111827;">{{ appName }}</h1>
      <p style="margin:0 0 4px;font-size:14px;color:#374151;">Set a password to accept and join.</p>
      <p *ngIf="roleName" style="margin:0 0 4px;font-size:14px;color:#374151;">You'll join as <strong style="color:#111827;">{{ roleName }}</strong>.</p>

      <div style="margin:18px 0 4px;">
        <label style="display:block;font-size:12px;color:#6b7280;margin-bottom:4px;">Email</label>
        <input [value]="email" disabled style="width:100%;box-sizing:border-box;padding:10px 12px;border:1px solid #e5e7eb;border-radius:10px;font-size:14px;background:#f9fafb;color:#111827;" />
      </div>

      <div style="margin:12px 0 4px;">
        <label style="display:block;font-size:12px;color:#6b7280;margin-bottom:4px;">Your name <span style="color:#9ca3af;">(optional)</span></label>
        <input [(ngModel)]="userName" type="text" autocomplete="name" style="width:100%;box-sizing:border-box;padding:10px 12px;border:1px solid #e5e7eb;border-radius:10px;font-size:14px;" />
      </div>

      <div style="margin:12px 0 4px;">
        <label style="display:block;font-size:12px;color:#6b7280;margin-bottom:4px;">Password</label>
        <input [(ngModel)]="password" type="password" autocomplete="new-password" style="width:100%;box-sizing:border-box;padding:10px 12px;border:1px solid #e5e7eb;border-radius:10px;font-size:14px;" />
      </div>

      <div style="margin:12px 0 4px;">
        <label style="display:block;font-size:12px;color:#6b7280;margin-bottom:4px;">Confirm password</label>
        <input [(ngModel)]="confirmPassword" type="password" autocomplete="new-password" (keyup.enter)="accept()" style="width:100%;box-sizing:border-box;padding:10px 12px;border:1px solid #e5e7eb;border-radius:10px;font-size:14px;" />
      </div>

      <p *ngIf="errorMsg" style="margin:10px 0 0;font-size:13px;color:#dc2626;">{{ errorMsg }}</p>

      <button (click)="accept()" [disabled]="submitting" style="margin-top:18px;width:100%;background:#111827;color:#fff;border:none;border-radius:10px;padding:12px 20px;font-size:15px;font-weight:600;cursor:pointer;opacity:1;">
        {{ submitting ? 'Accepting…' : 'Accept invite' }}
      </button>
    </div>

    <!-- Attach email (one-click confirm, no password) -->
    <div *ngIf="!loading && valid && !done && kind === 'attach_email'">
      <p style="margin:0 0 4px;font-size:12px;font-weight:600;letter-spacing:.4px;text-transform:uppercase;color:#6b7280;">Confirm email</p>
      <h1 style="margin:0 0 6px;font-size:22px;font-weight:600;color:#111827;">{{ appName }}</h1>
      <p style="margin:0 0 12px;font-size:14px;color:#374151;">Confirm adding <strong style="color:#111827;">{{ email }}</strong> to your account. Afterwards you can sign in with your username or this email.</p>
      <p *ngIf="errorMsg" style="margin:10px 0 0;font-size:13px;color:#dc2626;">{{ errorMsg }}</p>
      <button (click)="confirmEmail()" [disabled]="submitting" style="margin-top:8px;width:100%;background:#111827;color:#fff;border:none;border-radius:10px;padding:12px 20px;font-size:15px;font-weight:600;cursor:pointer;">
        {{ submitting ? 'Confirming…' : 'Confirm email' }}
      </button>
    </div>

    <!-- Done -->
    <div *ngIf="done" style="text-align:center;">
      <h1 style="margin:0 0 8px;font-size:20px;font-weight:600;color:#111827;">{{ kind === 'attach_email' ? 'Email confirmed ✓' : 'You\'re in 🎉' }}</h1>
      <p style="margin:0;font-size:14px;color:#6b7280;">{{ kind === 'attach_email' ? 'You can now sign in with this email or your username.' : 'Signing you in…' }}</p>
    </div>

  </div>
</div>
